import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { StampCardRow } from '@models/stamp';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import CircleProgress from '../CircleProgress';

interface Props {
    stampCard: StampCardRow;
    logExpand: boolean;
    setLogExpand: Dispatch<SetStateAction<boolean>>;
}

function StampProgress({ stampCard, logExpand, setLogExpand }:Props) {
    const { t } = useTranslation('stamp');
    const { stampCount, totalSlots } = stampCard;
    return (
        <Row spacing={16} align='flex-start' fullWidth >
            <CircleProgress count={stampCount} maxCount={totalSlots}/>
            <Column fullWidth spacing={8}>
                <Text size='xl' >
                    {t('card.remainingStamps', { count: totalSlots - stampCount })}
                </Text>
                <Text size='s' color={colors.gray6} onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setLogExpand((prev) => !prev);
                }}>
                    {t(logExpand ? 'card.historyHide' : 'card.historyView')}
                </Text>
            </Column>
        </Row>
    );
}

export default StampProgress;
